import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { generalCatalog } from "../../store/generalCatalog/actions";
export var useGeneralCatalogGetAll = function (trigger, clientId, type, code, description, pageCatalog, limitCatalog) {
    var _a = useState(true), enable = _a[0], setEnable = _a[1];
    var dispatch = useDispatch();
    var _b = useSelector(function (state) { return ({
        responseGeneralCatalog: state.GeneralCatalog.responseGeneralCatalog,
        errorGeneralCatalog: state.GeneralCatalog.errorGeneralCatalog,
        loadingGeneralCatalog: state.GeneralCatalog.loadingGeneralCatalog,
    }); }), responseGeneralCatalog = _b.responseGeneralCatalog, errorGeneralCatalog = _b.errorGeneralCatalog, loadingGeneralCatalog = _b.loadingGeneralCatalog;
    useEffect(function () {
        if (trigger) {
            dispatch(generalCatalog({
                clientId: clientId,
                enable: enable,
                page: pageCatalog,
                limit: limitCatalog,
                type: type,
                code: code,
                description: description,
            }));
        }
    }, [trigger, clientId]);
    return {
        responseGeneralCatalog: responseGeneralCatalog,
        errorGeneralCatalog: errorGeneralCatalog,
        loadingGeneralCatalog: loadingGeneralCatalog,
        setEnable: setEnable,
    };
};
